
export { default as FAQ } from "./FAQ"